<div class="field">
  <label for="SecurityGroupSelectorDd" class="do-not-wrap-text">{{labelKey}}</label>
    <p-dropdown #SecurityGroupSelectorDd
                [options]="securityGroups"
                dataKey="SECGROUPID"
                optionLabel="SECGROUPNAME"
              [filter]="true"
              [showClear]="true"
              [required]="true"
              [disabled]="_disabled"
              (onClick)="groupEditClick($event)"
                (onChange)="groupEditChange($event)"
                [(ngModel)]="selectedGroup"
                [placeholder]="placeholder"
                ></p-dropdown>
</div>
